import { createSlice } from "@reduxjs/toolkit";

const companiesSlice = createSlice({
  name: "companies",
  initialState: {
    companies: null,
    isFetching: false,
    error: false,
  },
  reducers: {
    companiesStart: (state) => {
      state.isFetching = true;
    },
    companiesSuccess: (state, action) => {
      state.companies = action.payload;
      state.isFetching = false;
      state.error = false;
    },
    companiesFailure: (state) => {
      state.isFetching = false;
      state.error = true;
    },
    deleteStart: (state) => {
      state.isFetching = true;
      state.error = false;
    },
    deleteSuccess: (state, action) => {
      state.companies = action.payload;
      state.isFetching = false;
      state.error = false;
    },
    deleteFailure: (state) => {
      state.isFetching = false;
      state.error = true;
    },
    logoutInfoCompanies: (state) => {
      state.companies = null;
      state.isFetching = false;
      state.error = false;
    },
  },
});

export const {
  companiesStart,
  companiesSuccess,
  companiesFailure,
  deleteStart,
  deleteSuccess,
  deleteFailure,
  logoutInfoCompanies,
} = companiesSlice.actions;

export default companiesSlice.reducer;
